import requirePropFactory from '@mui/utils/requirePropFactory';
export default requirePropFactory;


//////////////////
// WEBPACK FOOTER
// ../@mui/material/utils/requirePropFactory.js
// module id = 783
// module chunks = 22